import { render, staticRenderFns } from "./TrText.vue?vue&type=template&id=ec679c50&"
import script from "./TrText.vue?vue&type=script&lang=js&"
export * from "./TrText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports